import { Drawer, Text } from '@cinch-labs/design-system'
import { penceToPounds } from '@cinch-labs/shared-util'
import styles from './admin-fee-drawer.module.css'
import { Env, readFromEnv } from '@cinch-nx/environments'
import { useAdminFeeDrawer } from './admin-fee-drawer.context'

export const AdminFeeDrawer: React.FC = () => {
  const { showAdminFeeDrawer, setShowAdminFeeDrawer } = useAdminFeeDrawer()

  const adminFeeValueInPounds = penceToPounds(
    Number(readFromEnv(Env.AdminFeeValue)),
  )

  const handleClick = () => {
    setShowAdminFeeDrawer(!showAdminFeeDrawer)
  }

  return (
    <>
      {showAdminFeeDrawer && (
        <Drawer
          onClose={() => handleClick()}
          header={'Admin Fee'}
          ariaLabelledById="admin-fee-drawer"
        >
          <div>
            <Text fontSizeFixed="m" className={styles.p1}>
              The {adminFeeValueInPounds} admin fee powers your faff-free
              customer experience, including administration costs associated
              with processing your car.
            </Text>
            <Text fontSizeFixed="m">
              If you return your car using our 14-day money-back guarantee,
              we’ll give you a full refund, including the{' '}
              {adminFeeValueInPounds} admin fee.
            </Text>
          </div>
        </Drawer>
      )}
    </>
  )
}
